module.exports = __webpack_public_path__ + "assets/img/mo-guest-page-layer-15-2fa9c3ef.png";